'use strict';

var React = require('react');

var SvgPlanFilledIcon = function SvgPlanFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m14.208 4.688 1.533-2.3a.25.25 0 0 0-.208-.388h-3.066a.25.25 0 0 0-.208.389l1.533 2.299a.25.25 0 0 0 .416 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.25 7c0-.69.56-1.25 1.25-1.25h3.25c.69 0 1.25.56 1.25 1.25v8.75c0 .69-.56 1.25-1.25 1.25h-11.5c-.69 0-1.25-.56-1.25-1.25v-2.75c0-.69.56-1.25 1.25-1.25h2.75v-1.75c0-.69.56-1.25 1.25-1.25h3v-1.75Zm1.5.25v2.25h1.5v-2.25h-1.5Zm-4.25 3h1.5v2.25h-1.5v-2.25Zm-4 3h1.5v2.25h-1.5v-2.25Z"
  }));
};
SvgPlanFilledIcon.displayName = "PlanFilledIcon";

exports.SvgPlanFilledIcon = SvgPlanFilledIcon;
